module.exports = __webpack_public_path__ + "img/welcome.1d897a79.png";